import appRouter from "@/router";
import { useUserStore } from "@/stores/userStore";
import type { MobiusPlanType } from "@core/types";
import { currentDefaultVersion } from "@/assets/mobiusVersioningData";

const appVersion = currentDefaultVersion;

export function isIframePage(path: string) {
  const routes = appRouter.options.routes;

  for (let i = 0; i < routes.length; i++) {
    if (path === routes[i].path && !routes[i].name?.toString().startsWith("iframe")) {
      return false;
    }
  }
  return true;
}

export function loadIframe(route: string, isActiveSubscription: boolean): string {
  let iframeSrc = "";

  const path = route.split(appVersion).reverse()[0];

  if (!isIframePage(path) && !isActiveSubscription) {
    iframeSrc = "/subscription/billing";
  } else iframeSrc = path;

  return `${window.location.origin}/api/cwacc/${appVersion}${iframeSrc}`;
}

export function parseJwt(token: string) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  
  return JSON.parse(jsonPayload);
}

export function stripVersionTag(route: string): string {
  return route.replace(/^\/v\d+\.\d+/, "");
}

export function cookieExists(cookieName: string): boolean {
  return document.cookie.split(";").some(cookie => {
    return cookie.trim().startsWith(cookieName + "=");
  });
}

export function getCookieValue(cookieName: string): string | null {
  const match = document.cookie.match(new RegExp("(^|;)\\s*" + cookieName + "=([^;]*)"));
  return match ? decodeURIComponent(match[2]) : null;
}

export function currentPlanIs(plans: MobiusPlanType[]): boolean {
  const userStore = useUserStore();
  const planType = userStore.getPlanName(userStore.currentTenant?.subscription?.plan_id ?? "");
  
  return plans.includes(planType);
}

export function currentPlanIsNot(plans: MobiusPlanType[]): boolean {
  return !currentPlanIs(plans);
}
